import { createFileRoute } from '@tanstack/react-router';
import MyDossiers from '../../../features/dossiers/list/myDossiers';
import {
  createPermissionGuard,
  DOSSIER_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/vorgaenge/(listen)/meine')({
  component: MyDossiers,
  beforeLoad: createPermissionGuard(
    getPermissionSet(DOSSIER_PERMISSIONS, 'READ'),
  ),
});

export const ListMyDossiersRoute = Route;
